import script from "./OsbAlternativeLastProposals.vue?vue&type=script&setup=true&lang=js"
export * from "./OsbAlternativeLastProposals.vue?vue&type=script&setup=true&lang=js"

import "./OsbAlternativeLastProposals.vue?vue&type=style&index=0&id=1c9946c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c9946c2"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QField from 'quasar/src/components/field/QField.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer,QForm,QStepper,QStep,QSeparator,QField,QToolbar,QOptionGroup,QBanner,QBtn,QSpinnerHourglass,QSlider});
